module.exports = __webpack_public_path__ + "img/pedro_racing.53602e33.png";